export default {
  redisKey: [
    'SUCCESS_REFER_EARN',
    'HOW_DO_I_LOOK',
    'isDittoPDPDefaultView',
    'isDittoEnableGlobal',
    'sidebarVideosList',
    'isCatDittoView',
    'IS_LOYAL_CUSTOMER',
    'IS_LOYAL_CUSTOMER_OFFER',
    'LOYALTY_PID',
    'timerForWalletResendOTP',
    'LOYALTY_ALLOW_CLSFN',
    'LOYALTY_ALLOW_BRAND',
    'LOYALTY_ADD_BTN_TEXT',
    'LOYALTY_SKIP_BTN_TEXT',
    'LOYALTY_BAN_IMG',
    'LOYALTY_BAN_IMG_CHECKOUT',
    'LOYALTY_TC_HTML',
    'LOYALTY_HOVER_HTML',
    'LOYALTY_KNOW_IMG',
    'LOYALTY_ADDED_HTML',
    'LOGIN_EMAIL_INPUT',
    'LOGIN_EMAIL_INPUT_LABEL',
    'VC_FULL_RIM',
    'VC_HALF_RIM',
    'VC_RIMLESS',
    'ENABLE_FRESHWORKS_DESKTOP',
    'PRESCRIPTION_MODAL',
    'BLUE_CUT_LOGO',
    'SORT_PACKAGES_BY_PRICE_DESC',
    'SKIP_COATINGS_STEP',
    'SHOW_MORE_PAYMENT_OPTION',
    'SHOW_MORE_PAYMENT_OPTION_LIMIT',
    'CONFIG_CTA_DESKTOP',
    'ADDTOCART_BUTTON_CONFIG',
    'GOLD_MEMBERSHIP_CONFIG',
    'NEW_CARD_CONFIG',
    'MISSED_CALL_CONFIG',
    'TRY_ON_DESKTOP',
    'RBI_POLICY_MARKETPLACE_CONFIG',
    'IMPORT_JQUERY',
    'PDP_CL_BOX_CONFIG',
    'YOTPO_WIDGETS_CONFIG',
    'USER_SAVED_CARD',
    /* From Mobile Site */
    'ENABLE_FRESHWORKS',
    'UPDATE_TOAST_CONFIG',
    'PHONE_NUMBER_CAPTURE_CONFIG',
    'APP_DOWNLOAD_ONELINK',
    'NEW_CAPTURE_NUMBER_EXPIRY',
    'NEW_CAPTURE_NUMBER_CLOSE_EXPIRY',
    /* Category Page New additions */
    'PLP_CONFIG',
    /* Category Page New additions */
    'DISABLE_POWER_MISS_INFO',
    'SUBSCRIPTION_CONFIG',
    'quizConfig',
    'GUEST_MSG',
    'PDP_CONFIG',
    'SL_EXCEEDED_MESSAGE',
    'VC_FULL_RIM_MOBILE', 'VC_HALF_RIM_MOBILE', 'VC_RIMLESS_MOBILE',
    'MISSCALL_CONFIG',
    'lenskartGoldBanner',
    'TAT_INFO',
    'BUY_ON_CALL_CONFIG',
    'HIDE_RECENT_PRODUCTS', 'RECENT_VIEWED_TITLE', 'RECENT_VIEWED_COUNT', 'RECENT_VIEWED_PER_SLIDE',
    'HIDE_RECOMMENDED_PRODUCTS', 'RECOMMENDED_PRODUCTS_TITLE', 'RECOMMENDED_PRODUCTS_COUNT', 'RECOMMENDED_PRODUCTS_PER_SLIDE',
    'DISABLE_BUY_CALL',
    'OOS_CONFIG', 'PACKAGES_CONFIG',
    'BOGO_BANNER_DETAILS', 'SHOW_HIDE_LENSKART_GOLDBANNER', 'LKCashEnabled',
    'LK_CONFIG_MESSAGE', 'CONFIG_CTA_MSITE', 'BOGO_WORKFLOW', 'BOGO_OFFER_CONFIG',
    'CATEGORY_PAGE_SIZE_COUNT',
    'STORE_LOCATOR_URL',
    'LISTING_PAGE_SIZE',
    'SKIP_BTN_TIMEOUT',
    'MSITE_SHOW_MORE_PAYMENT_OPTION', 'MSITE_SHOW_MORE_PAYMENT_OPTION_LIMIT',
    'NEW_AUTH_CONFIG',
    'CL_SURVEY',
    'APP_DOWNLOAD_PUSH_CONFIG',
    'OFFLINE_ORDER_NUMBER',
    'MSITE_EYE_SUN_CTA_CONFIG',
    'BRAND_PRICE_APP_OFFER',
    'WHITELISTED_URL_FOR_SEO',
    'CONTACTS_OFFER',
    'PRODUCTS_GST',
    'WHATSAPP_OPTIN',
    'STORE_FRAME_SIZE',
    'isEmailMandatoryForDitto',
    'hideDittoPhoneCapture'
  ]
};
